import './FanRow.sass';

import { FC, useRef } from 'react';

import { UnitName, UnitPhoto, Verified } from '$shared/components';
import { useUserInfo } from '$hooks';

import { colorForType, labelForType, IncomeType } from '../StatisticsPro.types';

export interface FanRowProps {
  userId: number;
  rank: number;
  active: boolean;
  primary: string;
  secondary: string;
  topType: IncomeType | null;
  onClick: (centerRatio: number) => void;
}

export const FanRow: FC<FanRowProps> = ({
  userId,
  rank,
  active,
  primary,
  secondary,
  topType,
  onClick,
}) => {
  const user = useUserInfo(userId);
  const rowRef = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    const el = rowRef.current;
    const ratio = el
      ? (el.getBoundingClientRect().top + el.offsetHeight / 2) / window.innerHeight
      : 0.55;
    onClick(ratio);
  };

  const medalClass = rank <= 3 ? ` FanRow__rank--${rank}` : '';

  return (
    <div
      ref={rowRef}
      data-cursor-id={userId}
      className={`FanRow${active ? ' FanRow--active' : ''}`}
      onClick={handleClick}
    >
      <div className={`FanRow__rank${medalClass}`}>{rank}</div>
      <UnitPhoto unit={user} />
      <div className="FanRow__cont">
        <div className="FanRow__name_wrap">
          <div className="FanRow__name">
            <UnitName unit={user} />
          </div>
          <Verified objectId={userId} />
        </div>
        <div className="FanRow__caption">
          {topType && (
            <>
              <span
                className="FanRow__dot"
                style={{ backgroundColor: colorForType(topType) }}
              />
              <span className="FanRow__topType">{labelForType(topType)}</span>
              <span className="FanRow__sep">·</span>
            </>
          )}
          <span>{secondary}</span>
        </div>
      </div>
      <div className="FanRow__value">{primary}</div>
    </div>
  );
};
